import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import SummaryMain from "components/menu/summary/main";
// import SummaryTable7 from "components/menu/summary/main-table-7";

const SummaryRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={SummaryMain}
            />
            {/*
            <PrivateRoute
                exact
                path={`${props.match.url}/rt7`}
                component={SummaryTable7}
            />
            */}
        </Switch>
    </div>
);

export default connect()(SummaryRouter);
